export const CREATOR_MANAGER_RELATION = {
  manager: 'manager', // Creator that I manage directly
  coManager: 'coManager', // Creator in my agency that I co-manage
  inOwnAgencyTeam: 'inOwnAgencyTeam', // Creator in my agency that I don't manage directly
  externalCoManager: 'externalCoManager', // Creator shared with me from an external agency
  fromExternalAgencyTeam: 'fromExternalAgencyTeam', // Creator that has been shared with someone in my agency from an external agency
};
